import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../assets/logo.svg'
import _imports_1 from '../assets/user.png'
import _imports_2 from '../assets/password.png'
import _imports_3 from '../assets/right.png'
import _imports_4 from '../assets/btmimg.png'


const _hoisted_1 = { class: "content" }
const _hoisted_2 = { class: "data_cont" }
const _hoisted_3 = {
  class: "flex space_between",
  style: {"margin-top":"16px"}
}

import { reactive, ref, onMounted } from "vue";
import type { FormInstance, FormRules } from "element-plus";
import { ElMessage } from "element-plus";

import router from "@/router";
import { LoginPost } from "@/api/api";

export default /*@__PURE__*/_defineComponent({
  __name: 'login',
  setup(__props) {

const ruleForm = reactive({
  UserName: "",
  Password: "",
});
onMounted(() => {
  const resetAutofillStyle = (input: HTMLInputElement) => {
    setTimeout(() => {
      input.style.backgroundColor = "";
      input.style.color = "";
    }, 50);
  };
});

const ruleFormRef = ref<any | null>(null);

function submit() {
  ruleFormRef.value.validate((valid: any) => {
    if (valid) {
      let data = {
        UserName: ruleForm.UserName,
        Password: ruleForm.Password,
      };
      LoginPost(data).then((res: any) => {
        if (res?.code == 0) {
          ElMessage({
            message: "登录成功",
            type: "success",
          });
          localStorage.setItem("userinfo", JSON.stringify(res.data));
          localStorage.setItem("appToken", res.data.token);
          router.replace("/home2");
        } else {
          console.log(res?.message);

          ElMessage({
            message: res?.message || "登录失败",
            type: "error",
          });
        }
      });
    } else {
      console.log("错误提交!");
      return false;
    }
  });
}

const validateUserName = (rule: any, value: any, callback: any) => {
  if (value === "") {
    callback(new Error("请输入正确信息"));
  } else {
    if (ruleForm.UserName !== "") {
      if (!ruleFormRef.value) return;
    }
    callback();
  }
};

const rules = reactive<FormRules<typeof ruleForm>>({
  UserName: [{ validator: validateUserName, trigger: "blur" }],
  Password: [{ validator: validateUserName, trigger: "blur" }],
});

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[9] || (_cache[9] = _createStaticVNode("<div class=\"from_cont\" data-v-7be4d651><div class=\"logo\" data-v-7be4d651><div class=\"img\" data-v-7be4d651><img src=\"" + _imports_0 + "\" data-v-7be4d651></div><div class=\"name\" data-v-7be4d651>GalaxyQuantitativ</div></div><div class=\"tip_img\" data-v-7be4d651>登录</div></div>", 1)),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_form, {
        ref_key: "ruleFormRef",
        ref: ruleFormRef,
        model: ruleForm,
        "status-icon": "",
        rules: rules,
        class: "demo-ruleForm"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form_item, { prop: "UserName" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: ruleForm.UserName,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((ruleForm.UserName) = $event)),
                placeholder: "用户名/邮箱/手机号码"
              }, {
                prefix: _withCtx(() => _cache[5] || (_cache[5] = [
                  _createElementVNode("div", { class: "data__icon" }, [
                    _createElementVNode("img", { src: _imports_1 })
                  ], -1)
                ])),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, { prop: "Password" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                type: "password",
                modelValue: ruleForm.Password,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((ruleForm.Password) = $event)),
                placeholder: "请输入登录密码"
              }, {
                prefix: _withCtx(() => _cache[6] || (_cache[6] = [
                  _createElementVNode("div", { class: "data__icon" }, [
                    _createElementVNode("img", { src: _imports_2 })
                  ], -1)
                ])),
                suffix: _withCtx(() => [
                  _createElementVNode("div", {
                    class: "code_btn",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(router).push('/retrieve'))),
                    type: "info"
                  }, " 忘记密码 ")
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", {
              class: "sub_bnt back_home",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_unref(router).replace('/home')))
            }, _cache[7] || (_cache[7] = [
              _createElementVNode("div", { class: "name" }, "返回主页", -1)
            ])),
            _createElementVNode("div", {
              class: "sub_bnt",
              onClick: submit
            }, _cache[8] || (_cache[8] = [
              _createElementVNode("div", { class: "name" }, "立即登录", -1),
              _createElementVNode("div", { class: "img" }, [
                _createElementVNode("img", { src: _imports_3 })
              ], -1)
            ]))
          ])
        ]),
        _: 1
      }, 8, ["model", "rules"]),
      _createElementVNode("div", {
        class: "tip_cont",
        onClick: _cache[4] || (_cache[4] = ($event: any) => (_unref(router).push('/sign')))
      }, "创建一个账号？")
    ]),
    _cache[10] || (_cache[10] = _createElementVNode("div", { class: "logo_btm" }, [
      _createElementVNode("img", { src: _imports_4 })
    ], -1))
  ]))
}
}

})